import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ClaimListResponse} from '../../entity/claim-list-response';
import {ClaimItem} from '../../entity/claim-item';
import {ClaimListService} from '../../control/claim-list-service';
import {ClaimOverviewStatistics} from '../claim-overview-statistics/claim-overview-statistics';
import {ClaimList} from '../claim-list/claim-list';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {PageEvent} from '@angular/material/paginator';
import {SelectedYearProvider} from '../../control/selected-year-provider';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';
import {YearSelector} from '../year-selector/year-selector';

@Component({
  selector: 'app-claims-overview',
  imports: [
    ClaimOverviewStatistics,
    ClaimList,
    MatProgressSpinner,
    MatProgressSpinner,
    LocalizationPipePipe,
    YearSelector
  ],
  templateUrl: './claims-overview.html',
  styleUrl: './claims-overview.scss'
})
export class ClaimsOverview implements OnInit {
  protected isLoading: boolean = false;
  protected claimListResponse: ClaimListResponse = {claims: [], lastEvaluatedKey: ""};
  protected claimList: ClaimItem[] = []
  protected pageSize: number = 5000;

  constructor(
    private readonly claimService: ClaimListService,
    private readonly selectedYearProvider: SelectedYearProvider,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.fetchAllClaims();
  }

  private fetchAllClaims() {
    this.isLoading = true;
    this.cdr.detectChanges();
    this.claimService.getAllClaims(this.selectedYearProvider.year, this.pageSize)
      .then(r => {
        this.isLoading = false;
        this.claimListResponse = r;
        this.claimList = r.claims;
        this.cdr.detectChanges();
      })
      .catch(error => {
        this.isLoading = false;
        this.claimListResponse = {claims: [], lastEvaluatedKey: ""};
        this.claimList = [];
        this.cdr.detectChanges();
      });
  }

  onPageChange($event: PageEvent) {
    // Calculate if we're on the last page
    const currentPage = $event.pageIndex;
    const pageSize = $event.pageSize;
    const totalLength = $event.length;
    const isLastPage = (currentPage + 1) * pageSize >= totalLength;
    const hasMoreData = this.claimListResponse.lastEvaluatedKey !== "";

    if (isLastPage && hasMoreData) {
      this.claimService.getAllClaims(this.selectedYearProvider.year, this.pageSize, this.claimListResponse.lastEvaluatedKey)
        .then(r => {
          this.isLoading = false;
          this.claimListResponse = r;
          this.claimList = [...this.claimList, ...r.claims];
          this.cdr.detectChanges();
        })
        .catch(error => {
          this.isLoading = false;
          this.claimListResponse = {claims: [], lastEvaluatedKey: ""};
          this.claimList = [];
          this.cdr.detectChanges();
        });
    }
  }
}
